var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basket",class:{ invert: _vm.invert }},[_c('a',{attrs:{"href":"/panier"}},[_vm._v("Panier "),_c('span',{staticClass:"hide_if_no_order"},[_vm._v("("+_vm._s(_vm.nb_total)+")")])])])}
var staticRenderFns = []

export { render, staticRenderFns }